/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import _ from 'lodash';
import District from './District';
import MapLayout from '../../components/MapLayout';
import { getDistrictData } from '../../actions/district';
import fetch from '../../core/fetch';
import { addVisit } from '../../lib/utils';

const http = require('http');

const cieszanowStatRequests = () => {
  const limit = 5;
  for (let i = 0; i <= limit; i++) {
    fetch('http://gis.cieszanow.eu/opegiekamap/statistics', {
      method: 'POST',
      mode: 'no-cors',
    });
  }
};

export default {
  path: '/:district',

  async action(ctx) {
    if (ctx.params.district === 'gmina_cieszanow') {
      cieszanowStatRequests();
    }

    addVisit(ctx.params.district, '2');

    if (ctx.params.district === 'notFound') return null;
    await ctx.store.dispatch(getDistrictData(ctx.params.district));
    const data = await ctx.store.getState();
    return {
      title: data.district.district ? `${data.district.district.nazwa} - e-spdp.pl`: '',
      component: (
        <MapLayout>
          <District title={data.district.district ? data.district.district.nazwa : ''} />
        </MapLayout>
      ),
      description: data.district.district ? `${data.district.district.nazwa} - e-spdp.pl`: '',
    };
  },
};



// WEBPACK FOOTER //
// src/routes/district/index.js